/** Official Fortify Portal contact addresses. */

export const GENERAL_INQUIRIES_EMAIL = "info@fortifyportal.ca";

export const WITHDRAWAL_NOTICE_EMAIL = "withdraw@fortifyportal.ca";

export const PRIVACY_EMAIL = "privacy@fortifyportal.ca";

export const FORTIFY_CONTACT_ENTRIES = [
  { label: "General inquiries", email: GENERAL_INQUIRIES_EMAIL },
  { label: "Withdrawal and cancellation notices", email: WITHDRAWAL_NOTICE_EMAIL },
  { label: "Privacy inquiries", email: PRIVACY_EMAIL },
];
